import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {createSearchSettings} from 'src/openapi/admin/apis/ConferenceSearchSettingsApi';
import {SearchSettingsType as SearchSettingsTypes} from 'src/openapi/admin/models/SearchSettingsType';
import {useAppDispatch} from 'src/store/hooks';

import type {SearchSettingsRequest} from 'src/openapi/admin/models/SearchSettingsRequest';
import type {SuccessPayload} from 'src/typedef';

type Props = {
    conferenceId: number,
};

const DEFAULT_FORM: SearchSettingsRequest = {
    conferenceId: 0,
    searchSettings: SearchSettingsTypes.COMPANY,
    name: '',
    pbIds: [],
};

export const useAddSearch = ({conferenceId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        return Promise.resolve({type: '', payload: {
            success: true,
            error: false,
            data: {...DEFAULT_FORM, conferenceId},
        } as SuccessPayload<SearchSettingsRequest>});
    }, [conferenceId]);

    const saveDispatchAction = useCallback((searchSettingsRequest: SearchSettingsRequest,
        signal: AbortSignal,
    ) => apiDispatch(createSearchSettings({searchSettingsRequest}, {signal})), [apiDispatch]);

    return useCommonDataHook({
        initValue: DEFAULT_FORM,
        getDispatchAction,
        saveDispatchAction,
    });
};
